import baseUrl from './baseUrl';

const URL_UPDATE_VALE_REFEICAO = `${baseUrl}/vale-refeicao`;

const updateValeRefeicao = async vrData => {
  try {
    const data = await fetch(URL_UPDATE_VALE_REFEICAO, {
      method: 'POST',
      headers: {
        'Content-type': 'application/json',
        'Authorization': `Bearer ${localStorage.getItem('token')}`
      },
      body: JSON.stringify(vrData)
    });

    if (!data.ok) {
      throw new Error('Ocorreu um erro inesperado');
    }

    const response = await data.json();

    return response;
  } catch (error) {
    console.log(error);
  }
};

export default updateValeRefeicao;
